import React, { createContext, useCallback, useMemo, useState } from 'react';

export const MainContext = createContext();

export const MainProvider = ({ children }) => {

    const [status, setStatus] = useState({});
    
    function setAlert(alert='', confirmAction, cancelAction=()=>{}) {
        setStatus({ alert, confirmAction, cancelAction });
    }

    const value = { status, setStatus, setAlert };

    return(
        <MainContext.Provider value={value}>
            {children}
        </MainContext.Provider>
    );
};